import Typography from "antd/lib/typography";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { ISkillItem, ISkillLevelItem } from "@sol/sdk";
import { Tag } from "@sol/uikit/data-display/Tag/Tag";

type SkillsListItemProps = {
    item: ISkillItem;
    onClick?: () => void;
    selectedLevels?: ISkillLevelItem[];
    selected?: boolean;
    showLevelBadges?: boolean;
};

export const SkillsListItem = ({
    item,
    onClick,
    selectedLevels = [],
    showLevelBadges = false,
    selected,
}: SkillsListItemProps) => {
    const [t] = useTranslation();

    const renderLevelBadge = (selectedLevels: ISkillLevelItem[], skill: ISkillItem) => {
        const level = selectedLevels.find(selectedLevel => selectedLevel.skill === skill["@id"])?.level;
        return level ? (
            <Tag>{t("component.shared.SkillsList.skillLevel", { level })}</Tag>
        ) : (
            <Tag>{t("component.shared.SkillsList.noLevel")}</Tag>
        );
    };

    return (
        <li>
            <button
                className={clsx(
                    // pas de `justify-start` en base : il contredit le `justify-center` conditionnel
                    // (en v4 l'ordre des utilities a changé → justify-start l'emportait, cassant le centrage).
                    // Sans classe justify, le défaut flex = flex-start (cas showLevelBadges).
                    "group flex min-h-20 w-full flex-col items-start gap-2 overflow-hidden rounded-ant-lg px-ant-lg py-ant-sm text-left transition-all duration-200 ease-in-out hover:bg-ant-primary-hover",
                    {
                        "bg-primary": selected,
                        "justify-center": !showLevelBadges,
                    },
                )}
                type="button"
                onClick={onClick}
                title={item.shortTitle}
                data-cy="skills-list-item"
            >
                <Typography.Text
                    className={clsx(
                        "line-clamp-3 text-ant-lg text-ellipsis transition-all duration-200 ease-in-out group-hover:text-color-ant-base!",
                        {
                            "text-white": selected,
                        },
                    )}
                >
                    {item.code}. {item.shortTitle}
                </Typography.Text>
                {showLevelBadges && renderLevelBadge(selectedLevels, item)}
            </button>
        </li>
    );
};
